import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

type Return = 'noVoucherDiscount' | 'priceBelowMinCondition' | 'default';

export const usePriceLabelState = ({
  attributes,
}: {
  attributes?: unknown;
} = {}): Return => {
  const voucherDiscount = useResolvedVoucherDiscount(attributes);

  if (!voucherDiscount) {
    return 'noVoucherDiscount';
  }

  const isPriceBelowMinCondition =
    isConditionalDiscount(voucherDiscount) &&
    voucherDiscount.discountConditions.some(
      ({ productMeetsCondition }) => !productMeetsCondition
    );

  if (isPriceBelowMinCondition && voucherDiscount.conditionType === 'Price') {
    return 'priceBelowMinCondition';
  }

  return 'default';
};
